module.exports = __webpack_public_path__ + "assets/img/about-us.fdc98115.jpg";